import { Trans } from '@lingui/macro'
import { forwardRef, Ref } from 'react'
import { FieldError } from 'react-hook-form'

import { InputProps } from '../Input/input-types'
import { InputBase } from '../Input/InputBase'

function Email(
    {
        onErrorClick,
        ...props
    }: InputProps & { onErrorClick?: (message: string) => void },
    ref: Ref<HTMLInputElement>,
) {
    return (
        <InputBase
            ref={ref}
            {...props}
            renderError={(err: FieldError | string) => {
                if (typeof err === 'string') {
                    return err
                }
                if (err?.type === 'emailSuggestion') {
                    const autocorrectLabel = <u>{err?.message}</u>
                    return (
                        <span
                            onClick={() => {
                                onErrorClick?.(err.message ?? '')
                            }}
                        >
                            <Trans id="core.emailInput.emailSuggestion">
                                Did you mean {autocorrectLabel}?
                            </Trans>
                        </span>
                    )
                }
                return err?.message
            }}
        />
    )
}

export const EmailInput = forwardRef(Email)
